<script setup>
import { RouterView } from 'vue-router'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import CartDrawer from '@/components/shop/CartDrawer.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <AppHeader />
    
    <main class="flex-1">
      <RouterView />
    </main>
    
    <AppFooter />
    
    <!-- Cart Drawer -->
    <CartDrawer />
  </div>
</template>
